import {SecureService} from "@/services/superclasses/secure-service";
import {FormResponse} from "@/interfaces/form-response";
import {Supplement} from "@/interfaces/supplement";
import {SupplementOverview} from "@/interfaces/supplement-overview";
import {Status} from "@/interfaces/status";

const api = window.contextPath + '/rest/supplements';

export class SupplementSecureService extends SecureService {

    public create = async (data: Supplement): Promise<FormResponse<Supplement>> => {
        return this.data(await this.post<FormResponse<Supplement>>(api, data))
    }

    public update = async (id: number, data: Supplement): Promise<FormResponse<Supplement>> => {
        return this.data(await this.put<FormResponse<Supplement>>(api + "/" + id, data))
    }

    public move = async (id: number, newIndex: number, featured: boolean): Promise<Status> => {
        return this.data(await this.put<Status>(api + "/" + id + "/move", null,
            {
                params: {
                    newIndex: newIndex,
                    featured: featured
                }
            }))
    }

    public remove = async (id: number): Promise<void> => {
        return this.data(await this.delete(api + "/" + id));
    }

    public loadById = async (id: number): Promise<Supplement> => {
        return this.data(await this.get<Supplement>(api + "/" + id))
    };

    public loadByMember = async (args: {
        featured?: boolean,
        first?: number,
        max?: number
    }): Promise<SupplementOverview[]> => {
        return this.data(await this.get<SupplementOverview[]>(api + "/by-member",
            {
                params: args
            }))
    }

    public countByMember = async (args: {
        featured?: boolean
    }): Promise<number> => {
        return this.data(await this.get<number>(api + "/count-by-member",
            {
                params: args
            }))
    }
}

export const supplementSecureService = new SupplementSecureService()